import i18n from "src/i18n/config";
import { useThemeMode } from "src/providers/ThemeProvider";

import { SelectField } from "@shared/form/SelectField/SelectField";
import { SingleSelectFieldProps } from "@shared/form/SelectField/SelectField.types";

const options = [
    { label: i18n.t("pages:settingsPage.portalSettings.themeSwitch.light"), value: "light" },
    { label: i18n.t("pages:settingsPage.portalSettings.themeSwitch.dark"), value: "dark" },
    { label: i18n.t("pages:settingsPage.portalSettings.themeSwitch.browserPreference"), value: "browser" },
];

export const ThemeSwitcher = () => {
    const { themeMode, setThemeMode } = useThemeMode();

    const onChange: SingleSelectFieldProps["onChange"] = (_event, selectedOption) => {
        if (typeof selectedOption?.value !== "string") {
            return;
        }

        if (selectedOption.value !== "light" && selectedOption.value !== "dark" && selectedOption.value !== "browser") {
            return;
        }

        setThemeMode(selectedOption.value);
    };

    return (
        <SelectField
            disableSorting
            value={options.find((option) => option.value === themeMode)}
            options={options}
            onChange={onChange}
        />
    );
};
